import React from 'react'
import Auxiliary from '../../HOC/Auxiliary/Auxiliary';
import Banner from '../../Components/Banner/Banner';
import ContactForm from './Sections/ContactForm';
import ContactAddress from './Sections/ContactAddress';
const contactUs = props =>{
  return(
     <Auxiliary>
          <Banner brand="contactus">
             <h1 className="bg-text1 mb-1">Contact <span className="text-color2">Us</span></h1>
          </Banner>
          <section>
            <div className="contactus-form py-5">
                <div className="mx-width">
                    <h2 className="heading2">Let’s get in <span className="text-color2">touch</span></h2>
                    <div className="row pt-4">
                        <ContactForm />
                        <ContactAddress />
                    </div>
                </div>
            </div>
          </section>
     </Auxiliary>
  )
}
export default contactUs;